// extracted by mini-css-extract-plugin
export default {"login_form":"login_form_fziLF","img_box":"img_box_MqlS4","form_box":"form_box_FGf8Q","remember":"remember_y6o1X","submit_btn":"submit_btn_hrLNL","footer":"footer_FW6up"};